var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08333 16.6667C1.51042 16.6667 1.02014 16.4628 0.6125 16.0552C0.204861 15.6476 0.000694444 15.1569 0 14.5833V2.08333C0 1.51042 0.204167 1.02014 0.6125 0.6125C1.02083 0.204861 1.51111 0.000694444 2.08333 0H18.75C19.3229 0 19.8135 0.204166 20.2219 0.6125C20.6302 1.02083 20.834 1.51111 20.8333 2.08333V14.5833C20.8333 15.1562 20.6295 15.6469 20.2219 16.0552C19.8142 16.4635 19.3236 16.6674 18.75 16.6667H2.08333ZM10.4167 9.375L2.08333 4.16667V14.5833H18.75V4.16667L10.4167 9.375ZM10.4167 7.29167L18.75 2.08333H2.08333L10.4167 7.29167ZM2.08333 4.16667V2.08333V14.5833V4.16667Z",
    fill: "#6E1F22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a2b08eb50d74769817bef9728f623c07.svg";
export { ForwardRef as ReactComponent };